
  import { ApplicationUserModel, ShiftTeamTypeModel } from '@/libs/Api';
  import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
  import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
  import Page from '@/Page.vue';
  import { Component, Ref } from 'vue-property-decorator';
  import { applicationUserStore } from '@/libs/user-settings/+state/store';
  import { Guid } from '@/libs/common/functions/guid';
  import { shiftTeamTypesStore } from '@/libs/shift-team-types/+state/store';

  @Component({})
  export default class ShiftTeamTypeDialog extends Page {
      id!: string;
      dialog = false;
      valid = true;
      saving = false;
      loading = false;
      applicationUser: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
      shiftTeamType: ShiftTeamTypeModel | null = null;
      deleteDialog = false;
      deleting = false;

      @Ref() form!: any;

      get isNewItem(): boolean {
          return this.shiftTeamType?.id == Guid.EmptyGuid();
      }

      open(id: string) {
          this.dialog = true;
          this.id = id;
          this.load();
      }

      close() {
          this.dialog = false;
      }

      private load(): Promise<any> {
          if (this.id != Guid.EmptyGuid()) {
              this.loading = true;
              return new Promise((resolve, reject) => {
                  this.loadShiftTeamType()
                      .then((e) => {
                          this.loading = false;
                          resolve(e);
                      })
                      .catch((e: any) => {
                          reject(e);
                      });
              });
          } else {
              this.shiftTeamType = {
                  id: Guid.EmptyGuid(),
                  code: null,
                  name: null,
              } as ShiftTeamTypeModel;
              return new Promise((resolve) => {
                  resolve(null);
              });
          }
      }

      private loadShiftTeamType() {
          return new Promise((resolve, reject) => {
              shiftTeamTypesStore.dispatch(CrudAction.Get, { id: this.id });
              this.subscribe(shiftTeamTypesStore, CrudReponse.Get)
                  .then((e) => {
                      this.shiftTeamType = e;
                      resolve(e);
                  })
                  .catch((e: any) => {
                      reject(e);
                  });
          });
      }

      private save() {
          if (this.form.validate()) {
              const shiftTeamType = { ...this.shiftTeamType } as ShiftTeamTypeModel;
              this.saving = true;
              if (this.id == Guid.EmptyGuid()) {
                  shiftTeamTypesStore.dispatch(CrudAction.Create, { item: shiftTeamType });
                  this.subscribe(shiftTeamTypesStore, CrudReponse.Create)
                      .then(() => {
                          this.load().then(() => {
                              this.saving = false;
                              this.close();
                          });
                      })
                      .catch((e) => {
                          this.saving = false;
                          throw e;
                      });
              } else {
                  shiftTeamTypesStore.dispatch(CrudAction.Update, { item: shiftTeamType });
                  this.subscribe(shiftTeamTypesStore, CrudReponse.Update)
                      .then(() => {
                          this.load().then(() => {
                              this.saving = false;
                              this.close();
                          });
                      })
                      .catch((e) => {
                          this.saving = false;
                          throw e;
                      });
              }
          }
      }

      deleteClick() {
          this.deleteDialog = true;
      }

      deleteShiftTeamType() {
          this.deleting = true;
          shiftTeamTypesStore.dispatch(CrudAction.Delete, { id: this.id });
          this.subscribe(shiftTeamTypesStore, CrudReponse.Delete)
              .then(() => {
                  this.deleting = false;
                  this.deleteDialog = false;
                  this.close();
              })
              .catch(() => {
                  this.deleting = false;
              });
      }
  }
  